import apiRequest from './client';

// Permissions CRUD (denied, retire-based) + acces par page (menu_keys,
// accorde-based, 2026-09-17) d'un superviseur, gerees par la company.
// GET renvoie { supervisor, catalog:{actions,models}, denied:[...],
// menu_catalog:[{section,items:[{key,label}]}], menu_keys:[...] }.
export const getSupervisorPermissions = (supervisorId) =>
  apiRequest(`/supervisor-permissions/?supervisor=${encodeURIComponent(supervisorId)}`);

// denied = cles "<model>.<action>" RETIREES (tout le reste = autorise).
// menuKeys = cles de page ACCORDEES (rien par defaut) — les deux sont
// sauvegardees ensemble par le meme PUT.
export const setSupervisorPermissions = (supervisorId, denied, menuKeys) =>
  apiRequest(`/supervisor-permissions/?supervisor=${encodeURIComponent(supervisorId)}`, {
    method: 'PUT',
    body: { denied, menu_keys: menuKeys },
  });

// Superviseurs de la company (entite Supervisor dediee).
export const listSupervisors = () => apiRequest('/supervisors/');
